module.exports = __webpack_public_path__ + "img/5.a3263ea4.webp";